import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { FullLoader } from "@/components/ProtectedRoute";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    (async () => {
      if (!sessionId) { nav("/login", { replace: true }); return; }
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser(data);
        window.history.replaceState(null, "", "/dashboard");
        nav(data.onboarding_completed ? "/dashboard" : "/onboarding", { replace: true });
      } catch (error) {
        console.error("Google session exchange failed:", error);
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return <FullLoader />;
}
